//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import LazyHydrate from 'vue-lazy-hydration';
import syncCart from '~/middleware/_syncCart';
import BaseLayout from '~/components/BaseLayout.vue';
import navTypes from '~/store/constants/navTypes';

export default {
  name: 'Layout',
  components: {
    CartDrawer: () => import('~/components/checkout/components/CartDrawer.vue'),
    DefaultNavigationBar: () => import('~/components/layout/default/DefaultNavigationBar.vue'),
    LegalNavBar: () => import('~/components/layout/legal/LegalNavBar.vue'),
    NavigationBar: () => import('./NavigationBar.vue'),
    CheckoutNavBar: () => import('~/components/layout/checkout/CheckoutNavBar.vue'),
    GQNavBar: () => import('~/components/layout/checkout/GQNavBar.vue'),
    ConfirmationNavBar: () => import('~/components/layout/checkout/ConfirmationNavBar.vue'),
    Footer: () => import('~/components/layout/default/Footer.vue'),
    CheckoutFooter: () => import('~/components/layout/checkout/CheckoutFooter.vue'),
    BaseLayout,
    LazyHydrate,
  },
  data: () => ({
    modalActive: true,
  }),
  computed: {
    ...mapGetters([
      'navType',
      'packageInCart',
    ]),
    checkoutNav() {
      switch (this.navType) {
      case navTypes.checkout:
        return true;
      default:
        return false;
      }
    },
    isDefaultNav() {
      return this.navType !== 'checkout'
        && this.navType !== 'confirmation'
        && this.navType !== 'gq'
        && this.navType !== 'legal';
    },
    isLegalNav() {
      return this.navType === 'legal';
    },
    isGQ() {
      return this.navType === 'gq';
    },
    layoutBodyClass() {
      // Add top padding only for specific routes with hero sections
      const routesNeedingSpacing = [
        'index',
        'the-system',
        'results',
      ];

      const isErrorPage = this.navType === navTypes.error;
      const currentRouteName = this.$route?.name || '';
      const needsNavbarSpacing = routesNeedingSpacing.includes(currentRouteName) || isErrorPage;

      return {
        'layout-body--with-navbar-spacing': needsNavbarSpacing,
      };
    },
    footerComponent() {
      switch (this.navType) {
      case navTypes.confirmation:
      case navTypes.checkout:
        return 'CheckoutFooter';
      case navTypes.marketplace:
      case navTypes.gq:
        return '';
      default:
        return 'Footer';
      }
    },
    navbarProps() {
      if (this.navType === 'confirmation') return { bgColor: 'fc-bg-blue' };
      if (this.navType === 'checkout') return { bgColor: 'fc-bg-eggshell' };
      if (this.navType === 'legal') return { bgColor: 'fc-bg-white' };
      return { bgColor: 'fc-bg-transparent' };
    },
    nuxtTransitionProps() {
      switch (this.navType) {
      case navTypes.secondary:
      case navTypes.shop:
      case navTypes.checkout:
        return {
          name: 'fade',
          appear: true,
        };

      default:
        return {
          name: 'unknown',
          appear: true,
        };
      }
    },
  },
  beforeMount() {
    syncCart({ store: this.$store, route: this.$route });
  },
  beforeDestroy() {
    this.modalActive = false;
  },
};
